import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('fg_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('fg_cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('fg_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-fade-up">
      <div className="max-w-4xl mx-auto bg-charcoal rounded-2xl px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <span className="w-5 h-5 flex items-center justify-center mt-0.5">
            <i className="ri-shield-check-line text-rose text-lg" />
          </span>
          <p className="font-sans text-sm text-white/80 leading-relaxed">
            Wir verwenden Cookies, um dein Erlebnis auf unserer Website zu verbessern.{' '}
            <a href="/datenschutz" className="text-rose hover:text-rose-light underline cursor-pointer">
              Datenschutzerklärung
            </a>
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={decline}
            className="font-sans text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Ablehnen
          </button>
          <button
            onClick={accept}
            className="bg-rose hover:bg-rose-dark text-white font-sans text-sm font-medium px-5 py-2 rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}
